import { getPageName } from '@/constants/common';
import ArrowLeft from '@/icon/ArrowLeft';
import { cn, isHome } from '@/lib/utils';
import { IconButton } from '@era-ui';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Header: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const onClickBack = () => {
    navigate(-1);
  };

  return (
    <div
      data-html2canvas-ignore
      className={cn(
        'pt-4 px-4 flex justify-content h-12 fixed top-0 left-0 w-full z-50',
        isHome(location.pathname)
          ? 'bg-gradient-to-r from-red-900 to-red-600'
          : 'bg-white shadow-lg',
      )}
    >
      <IconButton onClick={() => onClickBack()}>
        <ArrowLeft color={isHome(location.pathname) ? '#fff' : '#0D0D0D'} />
      </IconButton>

      <div
        id="pageTitle"
        className={cn('ml-3 text-base text-neutral-950', {
          'text-white': isHome(location.pathname),
        })}
      >
        {getPageName(location.pathname)}
      </div>
    </div>
  );
};

export default Header;
